import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AliasBadgeViewModel, BadgeViewModel, GetBadge, GetBadgeInstance, RedeemBadge, RedeemParticipationBadge } from "../badges/BadgeStore";
import { Anchor, Box, Button, Heading, Image, Text } from "grommet";
import { AliasCard } from "../aliases/AliasCard";
import { format, parseJSON } from "date-fns";
import { useUser } from "../account/AccountStore";

const UXParticipationBadgeHome = () => {
    const [badge, setBadge] = React.useState({} as BadgeViewModel);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (id) {
            GetBadge(id).then((response) => {
                setBadge(response.result);
            });
        }
    }, [id]);

    const [error, setError] = React.useState("");

    const redeemBadge = () => {
        if (id) {
            RedeemParticipationBadge(badge.id).then((response) => {
                if (response.success) {
                    window.location.assign("/");
                } else {
                    setError(response.errors.join("\n"));
                }
            });
        }
    };

    const user = useUser();

    return (
        <>
            {!user.isAuthenticated && (
                <Box align="center" pad="medium">
                    <Text>
                        Please <Anchor href={`/account/signin?redirectUrl=/ue/badges/${id}`}>login here</Anchor> to view this page
                    </Text>
                </Box>
            )}
            {badge.id && (
                <Box align="center">
                    <Image src={badge.logoURI} width="100%" style={{ maxWidth: "200px" }} fit="contain" />
                    <Box gap="xsmall">
                        <Heading level={3}>{badge.name}</Heading>
                        <Text>{badge.description}</Text>
                    </Box>
                    {badge.isParticipationBadge && <Button label="Redeem this badge" onClick={redeemBadge}></Button>}
                    <Text>{error}</Text>
                </Box>
            )}
        </>
    );
};

export default UXParticipationBadgeHome;
